import React, {useState, useEffect } from "react";
import "./NewVessel.scss";
import VesselServices from "../../services/api/VesselServices";
import { useMainContext } from "../../dataproviders/MainDataProvider";
import { useAuthContext } from "../../dataproviders/AuthDataProvider";
import { useVesselContext } from "../../dataproviders/VesselDataProvider";

function NewVessel() {
  const mainContext = useMainContext();
  const authContext = useAuthContext();
  const vesselContext = useVesselContext();

  const [vesselData, setVesselData] = useState({
    vesselname: '',
    status: '',
  });

  const [validationErrors, setValidationErrors] = useState({
    vesselname: '',
    status: '',
  });

  const handleStatusChange = (newStatus) => {
    setVesselData((prevVesselData) => ({
      ...prevVesselData,
      status: newStatus,
    }));

    setValidationErrors((prevValidationErrors) => ({
      ...prevValidationErrors,
      status: '',
    }));
  };
  
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedDescription, setSelectedDescription] = useState('');

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
};

const handleOptionClick = (option, name) => {
  handleStatusChange(option);
  setSelectedOption(option);
  setSelectedDescription(name);
  setShowDropdown(false); // Hide the dropdown after an option is selected
};

const isOptionSelected = (option) => {
  return option === selectedOption ? 'selected' : '';
};

const handleHideDropdown = () => {
  setShowDropdown(false); 
};

const renderSelectTag = (option) => {
  if (option === selectedOption) {
      return (
          <span className="select-tag float-right">
              <i className="fa-solid fa-check "></i>
          </span>
      );
  }
  return (
      <span className="select-tag">
      </span>
  );
};

  const handleInputChange = (event) => {
    const fieldName = event.target.dataset.field;
    const { name, value } = event.target;

    setVesselData((prevVesselData) => ({
      ...prevVesselData,
      [name]: value,
    }));

    setValidationErrors((prevValidationErrors) => ({
      ...prevValidationErrors,
      [name]: value ? '' : `${fieldName} is required.`,
    }));
  };

  const handleSaveVessel = (e) => {
    const errors = {};
    if (!vesselData.vesselname) {
      errors.vesselname = 'Vessel name is required.';
    }
    else
    {
      const vesselReset = /^[a-zA-Z0-9 -~!@#$%^&*(),.<>{}|;':"]*$/;
      if(!vesselReset.test(vesselData.vesselname))
      {
          errors.vesselname = 'Vessel name allows only lowercase, uppercase, numbering, space, and symbol characters.';
      }
    }

    if (!vesselData.status) {
      errors.status = 'Status is required.';
    }

    setValidationErrors(errors);

    
    if (Object.keys(errors).length === 0) {
        vesselData.status = parseInt(vesselData.status);
        //Send data to server
        saveVessel(vesselData);
       
    }
  };

    const saveVessel = async (newvessel) => {
        const cancelButton = document.getElementById("btnSaveVessel");

        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            const result = await VesselServices.AddVessel(newvessel.vesselname, newvessel.status);

            if (!!result) {
                if (typeof result.data.errormessage === 'undefined' || result.data.errormessage === null || result.data.errormessage === "") {
                    handleError('Success', 'Vessel has been successfully saved.');
                    vesselContext.SetRefreshFlag(true);
                }
                else {
                    handleError('Error', `Vessel has failed to save due to ${result.data.errormessage.toLowerCase()} Please try again.`);
                }
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Vessel has failed to save due to system error. Please try again.');
            }

            handleCancel();
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
  };

    const handleCancel = () => {
        resetForm();

        mainContext.HandleAddVessel(false);
    };

    const handleError = (errorType, errorMessage) => {
        authContext.HandleError(errorType, errorMessage);
    }

const resetForm = () => {
    setVesselData({
      vesselname: '',
      status: '',
    });

    setValidationErrors({
      vesselname: '',
      status: '',
    });
    setSelectedOption('');
    setSelectedDescription('');
    setShowDropdown(false);
}

  useEffect(() => {
   
}, []);

  return( 
    <>
      <div className={`dialog-overlay ${mainContext.ShowAddVessel  ? '' : 'hidden'}`}>
      <div className="dialog-container dialog-container-long">
          <button className="dialog-close-button" onClick={handleCancel} >
                <i className="fa-solid fa-xmark"></i>
          </button>
          <p className="dialog-title col-rps-light mt-0 mb-0">New Vessel</p>
          <div className="dialog-content">
            <div className="mb-2">
            <div className="d-flex align-items-center input-label-group">
              <label htmlFor="txtVesselName" className="w-30 required">Vessel Name</label>
              <input id="txtVesselName" className={`${validationErrors.vesselname ? 'error' :''} w-70`} type="text"  name="vesselname" data-field="Vessel Name"
              value={vesselData.vesselname} 
              onChange={handleInputChange}
              onFocus={handleHideDropdown}
              required
              />
            </div>
              {validationErrors.vesselname && (
            <label className="error error-message">
            <i className="fa-solid fa-circle-info"></i> {validationErrors.vesselname}
        </label>
          )}
            </div>
            <div className="mb-2">
              <div className="d-flex align-items-center input-label-group">
                    <label htmlFor="ddlStatus" className="w-30 required">Status</label>
                    <button id="ddlStatus" className={`btn-dropdown w-70 ${validationErrors.status ? 'dropdown-error' :''} ${showDropdown ? 'btn-dropdown-expanded' : ''}`} onClick={toggleDropdown}>
                        <span id="ddlSelectedOption" className="btn-dropdown-text float-left">{selectedDescription}</span>
                        <span className={`btn-dropdown-direction float-right ${showDropdown ? 'col-rps' : ''}`}><i className={`fa-solid fa-chevron-down`}></i></span>
                    </button>
                    <div className={`dropdown-content ${showDropdown ? 'd-block' : 'd-none'}`}>
                      <div className={`dropdown-content-link ${isOptionSelected('1')}`} onClick={() => handleOptionClick('1', 'Enabled')}><span>Enabled</span>{renderSelectTag('1')}</div>
                      <div className={`dropdown-content-link ${isOptionSelected('2')}`} onClick={() => handleOptionClick('2', 'Disabled')}><span>Disabled</span>{renderSelectTag('2')}</div>
                </div>
            </div>
            {validationErrors.status && (
          <label className="error error-message">
          <i className="fa-solid fa-circle-info"></i> {validationErrors.status}
      </label>
          )}
            </div>
          </div>
          <div className="dialog-buttons float-right">
              <button id="btnSaveVessel" className="btn btn-dialog btn-primary btn-me"  onClick={handleSaveVessel}>Save</button>
              <button className="btn btn-dialog btn-secondary"  onClick={handleCancel}>Cancel</button>
          </div>
      </div>
      </div>
    </>
  );
}

export default NewVessel;
